import { styled } from '@linaria/react';
import PopTopicCardSkeleton from '@fe-news/components/molecules/PopTopicCardSkeleton';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 24px;
  row-gap: 34px;
`;

const MyPopTopicContentSkeleton = () => {
  return (
    <Container>
      {Array.from({ length: 5 }).map((_, index) => (
        <PopTopicCardSkeleton key={`pop_topic_card_skeleton_${index}`} />
      ))}
    </Container>
  );
};

export default MyPopTopicContentSkeleton;
